module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/feature-1-image.png?ce2b8401";